import React from "react";
import "./Loader.css";

let Loader = props => (
  <div className="Loader pt-xl pb-xl">
    <div className="spinner" />
  </div>
);

export default Loader;
